import { LinkRenderer } from './renderers/LinkRenderer';
import { ParagraphRenderer } from './renderers/ParagraphRenderer';
import { ScrollViewRenderer } from './renderers/ScrollViewRenderer';
import { TextRenderer } from './renderers/TextRenderer';

export const offerRenderers = {
  ...TextRenderer,
  ...ParagraphRenderer,
  ...LinkRenderer,
  ...ScrollViewRenderer,
};

export { ScreensRenderer } from './ScreensRenderer';
export { parseScreens } from './schema';
export type { Screen, ASTNode } from './schema';
